export const GET_CAPTCHA_LINK = 'GET_CAPTCHA_LINK'
export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION'
export const RESET_SUBSCRIPTION = 'RESET_SUBSCRIPTION'
export const SET_DOWNLOAD_INFO = 'SET_DOWNLOAD_INFO'
export const SET_COMMISSION_INFO = 'SET_COMMISSION_INFO'
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS'
export const SET_USER_INFO = 'SET_USER_INFO'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js